import React from 'react';
import {Button} from '@/components/atoms';
import PropTypes from 'prop-types';

const SimpleButtonControl = (props) => {
  /**
   * Props for the SimpleButtonControl component.
   *
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle change events.
   * @property {string} path - Path to the data in the form.
   * @property {Object} schema - JSON schema for the form data.
   * @property {Object} uischema - UI schema for the form layout.
   * @property {boolean} enabled - Flag to indicate if the button is enabled.
   */
  const {handleChange, path, schema, uischema, enabled} = props;

  return (
    <Button
      title={schema.title}
      handleButton={(name) => handleChange(path, name)}
      schema={schema}
      uiSchema={uischema}
      disabled={!enabled}
    />
  );
};

SimpleButtonControl.propTypes = {
  handleChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired
};

export default React.memo(SimpleButtonControl);
